/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const ProductObjectMobile = lazyLoad(
  () => import('./index'),
  module => module.ProductObjectMobile
);
